
import weekLoading from '/public/lottie/weekLoading/loading.json'
import { dealLottiePath } from '@/utils/prefixLottie'
import lottie from 'lottie-web'
import { onMounted } from 'vue'
export default {
  props: {
    progress: { type: Number, default: 0 }
  },
  setup() {
    const renderLottie = () => {
      let lottie_json = weekLoading
      const lottiePath =
        process.env.NODE_ENV === 'development' ? '/images/loading/' : '/ibook/images/loadImg/'
      const newLottiePath = dealLottiePath(lottiePath)
      lottie_json?.assets?.forEach((item) => {
        item.u = lottiePath
      })

      lottie.loadAnimation({
        container: document.getElementById('lottie-container-weekloading'), // 元素动画容器
        renderer: 'svg',
        loop: true,
        animationData: lottie_json // the path to the animation json
      })
    }
    onMounted(() => {
      const dom = document.getElementById('lottie-container-weekloading')
      if (dom) {
        dom.innerHTML = ''
      }
      renderLottie()
    })
  }
}
